import styles from "./sectionHeader.module.css";

/**
 * Opens a section of the questionnaire ("פרטי הפונה", "מהות הפנייה"): a heading across the chat
 * between the questions, so it does not read as something Venchy said.
 */
function SectionHeader({ text }: { text: string }) {
  return (
    <div className={styles.sectionHeader} data-testid="section-header">
      <span className={styles.sectionHeader__line} />
      <h2 className={styles.sectionHeader__title}>{text}</h2>
      <span className={styles.sectionHeader__line} />
    </div>
  );
}

export default SectionHeader;
